//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ProductInfoList from "./ProductInfoList";
export default {
  components: {
    ProductInfoList: ProductInfoList
  },
  data: function data() {
    return {
      tabKeys: "2",
      projectCode: ''
    };
  },
  created: function created() {
    if (window.localStorage.getItem('projectCode')) {
      this.projectCode = window.localStorage.getItem('projectCode');
    }

    this.tabKeys = "2";
  },
  computed: {},
  methods: {}
};